import { User, LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { PushNotificationToggle } from '@/components/notifications/PushNotificationToggle';

export function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="flex h-16 items-center justify-end border-b bg-card px-6">
      {/* Actions */}
      <div className="flex items-center gap-4">
        {/* Push Notifications */}
        <PushNotificationToggle />

        {/* User Menu */}
        <div className="flex items-center gap-3">
          <div className="text-right">
            <p className="text-sm font-medium">{user?.name}</p>
            <p className="text-xs text-muted-foreground">{user?.roles[0]}</p>
          </div>
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-primary-foreground">
            <User className="h-5 w-5" />
          </div>
          <button
            onClick={logout}
            className="rounded-lg p-2 text-muted-foreground hover:bg-muted hover:text-foreground"
            title="Sair"
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
